import React from "react";
import ReactApexChart from "react-apexcharts";
import { useTheme } from "@mui/material/styles";

const PieChart = ({ series, labels, colors }) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  const defaultSeries = [44, 55, 13, 43, 22];
  const defaultLabels = ["Team A", "Team B", "Team C", "Team D", "Team E"];

  const chartSeries = series?.length ? series : defaultSeries;
  const chartLabels = labels?.length ? labels : defaultLabels;

  const labelColor = theme.palette.text.primary;
  const ttTheme = isDark ? "dark" : "light";

  const options = {
    chart: {
      type: "pie",
      background: "transparent",
    },
    labels: chartLabels,
    colors: colors || undefined, // If not provided, ApexCharts uses default palette
    legend: {
      position: "bottom",
      labels: {
        colors: labelColor,
      },
      markers: {
        width: 12,
        height: 12,
        radius: 12,
      },
      itemMargin: {
        horizontal: 10,
        vertical: 5,
      },
    },
    tooltip: {
      theme: ttTheme,
      y: {
        formatter: (val) => `${val}`,
      },
    },
    stroke: {
      show: true,
      colors: [theme.palette.background.paper], 
      width: 2,
    },
    dataLabels: {
      enabled: false,
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          legend: {
            position: "bottom",
          },
        },
      },
    ],
  };

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        minHeight: "150px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <ReactApexChart
        key={`pie-chart-${chartSeries.join(',')}`}
        options={options}
        series={chartSeries}
        type="pie"
        width="100%"
        height="100%"
      />
    </div>
  );
};

export default PieChart;
